export default __webpack_public_path__ + "static/media/aliexpress.e6d5e4a4.png";